import useText from "constants/text";
import { BrandIcon } from "icons";
import React from "react";
import { StyledHeaderContainer, StyledHeaderContent } from "../style";

function Header() {
  const { text } = useText();
  return (
    <StyledHeaderContainer>
      <StyledHeaderContent>
        <p className="brand-title">
          {text.fidelity_program.brand_title}{" "}
          <span className="brand-title-important">{text.fidelity_program.fidelity_program} </span>
          {` ${text.all.offered_by} `} <span className="brand-title-paps"> paps</span>
        </p>
        <div className="brand-image">
          <BrandIcon />
        </div>
      </StyledHeaderContent>
    </StyledHeaderContainer>
  );
}

export default Header;
